import { connect } from 'react-redux';
import MrfApprovalsList from './mrfApprovalsList';
import { bindActionCreators } from 'redux';
import {
  getApprovalList,
  acceptApproval,
  rejectApproval,
} from 'services/redux/approvals/mrfApprovals/action';

const mapStateToProps = (state) => ({
  approvalList: state.mrfApprovalReducer.approvalList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getApprovalList,
      acceptApproval,
      rejectApproval,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MrfApprovalsList);
